import { field, readContract, toBool, writeContractAndWait } from "../viem";
import MafiaPerkOpenerAbi from "../../abis/MafiaPerkOpener.json";
import config from "../../config/config";
import { UserNonceStatus } from "../../types/MafiaPerkOpener";

const address = config.perkOpener;
const abi = MafiaPerkOpenerAbi;

export const requestOpenPerkBox = async (account: string, itemId: number) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "requestOpenPerkBox",
    args: [itemId],
    account,
  });

  return tx;
};

export const finishOpenPerkBox = async (account: string) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "finishOpenPerkBox",
    account,
  });

  return tx;
};

export const getNonceStatus = async (account: string) => {
  const userNonceStatus = await readContract({
    address,
    abi,
    functionName: "getNonceStatus",
    args: [account],
    useWallet: true,
  });

  return toBool(userNonceStatus);
};

export const getUserNonceStatus = async (account: string) => {
  const userNonceStatus: UserNonceStatus = await readContract({
    address,
    abi,
    functionName: "userNonceStatus",
    args: [account],
    useWallet: true,
  });

  return {
    isPending: toBool(field(userNonceStatus, "isPending", 0)),
    requestBlock: Number(field(userNonceStatus, "requestBlock", 1) ?? 0),
  } as UserNonceStatus;
};
